import { Link } from 'react-router-dom';
import { ReactNode } from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'white' | 'outline-white' | 'danger';

interface ButtonProps {
  children: ReactNode;
  href?: string;
  variant?: ButtonVariant;
  className?: string;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const variantStyles: Record<ButtonVariant, string> = {
  primary: 'bg-mk-pink-600 text-white hover:bg-mk-pink-700',
  secondary: 'bg-gray-100 text-gray-700 hover:bg-gray-200',
  outline: 'border-2 border-mk-pink-600 text-mk-pink-600 hover:bg-mk-pink-50',
  white: 'bg-white text-mk-pink-600 hover:bg-gray-100',
  'outline-white': 'border-2 border-white text-white hover:bg-white/10',
  danger: 'bg-red-600 text-white hover:bg-red-700',
};

export default function Button({
  children,
  href,
  variant = 'primary',
  className = '',
  onClick,
  disabled = false,
  type = 'button',
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-3 rounded-xl font-semibold transition-colors';
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : '';
  const styles = `${baseStyles} ${variantStyles[variant]} ${disabledStyles} ${className}`;

  if (href && !disabled) {
    // Support both internal routes and anchor links
    if (href.startsWith('#')) {
      return (
        <a href={href} className={styles}>
          {children}
        </a>
      );
    }
    return (
      <Link to={href} className={styles}>
        {children}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={styles}>
      {children}
    </button>
  );
}
